import React from 'react'

const Seperator = () => {
  return (
    <svg width="12px" height="25px" viewBox="0 0 12 25" version="1.1">
      <defs>
        <path d="M6,1 L11.2889849,1" id="path-1" />
        <filter
          x="-113.4%"
          y="-850.0%"
          width="440.3%"
          height="1800.0%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feMorphology
            radius="1.5"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dx="3"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feMorphology
            radius="1.5"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          />
          <feOffset dx="3" dy="0" in="shadowInner" result="shadowInner" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.188235294   0 0 0 0 0.673839114   0 0 0 0 0.952941176  0 0 0 0.39637115 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g
        id="mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <g
          id="New-flow_06-Copy-2"
          transform="translate(-182.000000, -412.000000)"
        >
          <g id="Group-10-Copy-2" transform="translate(187.000000, 413.000000)">
            <g
              id="Group-10-Copy"
              transform="translate(1.000000, 11.500000) rotate(-270.000000) translate(-1.000000, -11.500000) translate(-10.500000, 10.500000)"
            >
              <g id="Group-15">
                <path
                  d="M1.58628666e-12,1 L23,1"
                  id="Line-3"
                  stroke="#D8D8D8"
                />
                <g id="Line-3">
                  <use
                    fill="black"
                    fillOpacity="1"
                    filter="url(#filter-2)"
                    xlinkHref="#path-1"
                  />
                  <use stroke="#30ACF3" strokeWidth="3" xlinkHref="#path-1" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Seperator
